import { z } from 'zod';
import { idSchema, dateSchema, emailSchema, urlSchema, optionalDateSchema } from './common';

/**
 * USER API SCHEMAS
 * Guards against malformed user profile and identity responses.
 */

export const careerGoalSchema = z.object({
  date: dateSchema,
  goal: z.string().nullable().optional().transform((v) => v ?? '')
});

export const userProfileSchema = z.object({
  id: idSchema,
  name: z.string().nullable().optional().transform((v) => v ?? 'Unknown User'),
  email: z.string().nullable().optional().transform((v) => v ?? ''),
  email2: emailSchema,
  type: z.string().nullable().optional().transform((v) => v ?? undefined),
  clientId: idSchema.optional(),
  avatar: urlSchema,
  createdAt: optionalDateSchema,
  updatedAt: optionalDateSchema,
  linkedin: urlSchema,
  title: z.string().nullable().optional().transform((v) => v ?? undefined),
  company: z.string().nullable().optional().transform((v) => v ?? undefined),
  city: z.string().nullable().optional().transform((v) => v ?? undefined),
  country: z.string().nullable().optional().transform((v) => v ?? undefined),
  timezone: z.string().nullable().optional().transform((v) => v ?? undefined),
  status: z.string().nullable().optional().transform((v) => v ?? undefined),
  careerGoals: z.array(careerGoalSchema).default([])
});

export type UserProfileResponse = z.infer<typeof userProfileSchema>;
